export default {
  betsonic: () => import('./betsonic/skin'),
  wplay: () => import('./wplay/skin')
}
